angular.module('impactx.cscontract').controller('CSContractModelListCtrl',  [
    '$scope',
    '$redirect',
    '$controller',
    'PartialDialogsService',
    'dataGen',
    'ToastService',
    'selectedListItems',
    'ConfirmationService',
    '$mdDialog',
    'AppConfiguration',
    CSContractModelListCtrl]);

function CSContractModelListCtrl($scope, $redirect, $controller, PartialDialogsService, dataGen, ToastService, selectedListItems, ConfirmationService, $mdDialog, AppConfiguration) {
    var mainCtrl = $controller('CSContractListCtrl', {});
    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.CONTRACT, 'cscontractmodellist');
    var self = this;

    this.delete = function() {
        var temp = {};
        dataGen.postAsForm(temp, {cscId: selectedListItems.getFirstSelectedId()}, "/cscontract/delete").then(function() {
            mainCtrl.meta.refreshListData({unselectRow: selectedListItems.getFirstSelectedItem()});
            ToastService.openStandardToast(temp.trns.deleteSuccess);
        });
    };

    this.deleteDialog = function(event, trns) {
        ConfirmationService.showConfirmationDialog(self.delete, event, trns.confirmDelete,
            trns.delete, trns.abort);
    };

    this.canDelete = function () {
        return selectedListItems.isSingleSelection() && !impactX.isDefined(selectedListItems.getFirstSelectedItem(), "deleted")
            && !impactX.isDefined(selectedListItems.getFirstSelectedItem(), "isMDM.value");
    };

    this.copyContract = function(event, trns) {
        $mdDialog.show({
            controller: "ContractCompanySelectionDialogCtrl",
            controllerAs: "contractCompanySelectionDialogCtrl",
            templateUrl: "modules/cscontract/templates/cscontracompanyselection.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                headerLabel: trns.copyContract,
                cscId: selectedListItems.getFirstSelectedItem().id
            }
        })
            .then(function(answer) {
                const params = {
                    cscId: selectedListItems.getFirstSelectedItem().id,
                    buyerComId: answer.buyerComId,
                    supplierComId: answer.supplierComId,
                    catalogId: answer.catalogId,
                    contactBuyerId: answer.contactBuyerId
                };
                dataGen.postAsForm({}, params, "/cscontract/copy").then(function (data) {
                    if(data.data.id > 0)
                    {
                        $redirect.redirectTo(null, "/contract/" + data.data.id);
                    }
                });
            }, function() {
            });
    };

    this.canCopy = function () {
        return selectedListItems.isSingleSelection();
    };

    var buttonDefinition = mainCtrl.buttonDefinition;
    buttonDefinition.push({label: "delete", action: self.deleteDialog, condition: self.canDelete, process: 'EditCSC'});
    if(!AppConfiguration.get("lotAvailable")) {
        buttonDefinition.push({label: "copyContract", action: self.copyContract, condition: self.canCopy, process: 'EditCSC'});
    }

    mainCtrl.meta = {
        rowTemplate: 'modules/cscontract/templates/cscontractlist.row.tmpl.html',
        filtersTemplate: 'modules/cscontract/templates/cscontractlist.filters.tmpl.html',
        endpoint: '/cscontract/model/list',
        ctrl: mainCtrl,
        id: "cscontractmodellist",
        buttonDefinition: buttonDefinition,
        excelParams: {
            params: [{param: 'LotId', intValue: 0},
                {param: 'TenderId', intValue: 0}]
        },
        mainActionFunction : {id:"new", action: mainCtrl.createContract, icon:"mdi-plus"},
        isSelectAble: true
    };
    this.getMeta = function ()
    {
        return mainCtrl.meta;
    };
    mainCtrl.contractType = "model";
    $scope.$watch(function() {
        return mainCtrl.contractType;
    }, function(newValue) {
        if(newValue == "basic") {
            $redirect.redirectTo(null, "/cscontractlist");
        }
    });
}